<template>
  <div class="m-create-user-existing">
    <base-input
      v-model="value.customerNumber"
      v-validate="'required'"
      class="-address-form"
      type="text"
      :label="$t('createUserExistingCustomerNumber', 'Kundenummer')"
      name="create-user-existing-customer-number"
      :error-message="$t('createUserExistingCustomerNumberErrorMsg', 'Indtast venligst et kundenummer')"
      :aria-label="$t('createUserExistingCustomerNumber', 'Kundenummer')"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.email"
      v-validate="'required|email'"
      class="-address-form"
      type="text"
      :label="$t('createUserExistingEmail', 'Email')"
      name="create-user-existing-email"
      :error-message="$t('createUserExistingEmailErrorMsg', 'Indtast venligst din email')"
      :aria-label="$t('createUserExistingEmail', 'Email')"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.fullName"
      v-validate="'required'"
      class="-address-form"
      type="text"
      :label="$t('createUserExistingFullName', 'Fulde navn')"
      name="create-user-existing-full-name"
      :error-message="$t('createUserExistingFullNameErrorMsg', 'Indtast venligst dit fulde navn')"
      :aria-label="$t('createUserExistingFullName', 'Fulde navn')"
      show-feedback-icon
      required
    />
    <base-input
      ref="password"
      v-model="value.password"
      v-validate="'required|min:8'"
      type="password"
      :label="$t('createUserExistingPassword', 'Adgangskode')"
      name="password"
      :custom-error-messages="{
        'required': $t('createUserExistingPasswordRequiredErrorMessage', 'Udfyld venligst en gyldig adgangskode'),
        'min': $t('createUserExistingPasswordMinErrorMessage', 'Adgangskoden skal være på minimum 8 karakterer'),
      }"
      :show-feedback-icon="true"
      :aria-label="$t('createUserExistingPassword', 'Adgangskode')"
      required
      class="-address-form"
    />
    <base-input
      v-model="value.passwordConfirm"
      v-validate="'required|confirmed:password'"
      type="password"
      :label="$t('createUserExistingPasswordConfirm', 'Bekræft adgangskode')"
      name="password-confirm"
      :error-message="$t('createUserExistingPasswordConfirmInvalid', 'Adgangskode svarer ikke til hinanden')"
      :show-feedback-icon="true"
      :aria-label="$t('createUserExistingPasswordConfirm', 'Bekræft ny adgangskode')"
      required
      class="-address-form"
    />
    <div class="d-flex flex-grow-1 justify-content-center mt-9">
      <button-with-loader
        :loading="isLoading"
        :text="$t('createUserSubmit', 'Indsend til godkendelse')"
        class="-primary py-4"
        @click.native="submitForm"
      />
    </div>
    <div v-if="showError" class="col-12 bg-red color-white p-4 mt-4">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/atoms/BaseInput';
import ButtonWithLoader from '@/components/molecules/ButtonWithLoader';
import { trackFormSubmission } from '@/utils/enhancedTracking'

export default {
  name: 'CreateUserExisting',
  components: {
    BaseInput,
    ButtonWithLoader
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      isLoading: false,
      showError: false,
      errorMessage: '',
    }
  },
  computed: {
    currentCulture () {
      return this.$store.getters['site/getCurrentCulture'];
    },
    generalErrorMessage () {
      return this.$t('createUserExistingGeneralErrorMessage','Der skete desværre en fejl. Forsøg igen senere.');
    }
  },
  methods: {
    async submitForm () {
      this.showError = false;
      this.isLoading = true;
      const allFieldsValid = await this.$validator.validate();

      if (!allFieldsValid) {
        /**
         * Could we do this easier?
         */
        const yOffset = -125;
        const fieldName = this.errors.items[0].field;
        const element = document.getElementById(fieldName);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});

        this.isLoading = false;
        return;
      }

      const fullName = this.value.fullName;
      let firstName = '';
      let lastName = '';

      if (fullName.includes(' ')) {
        firstName = fullName.substring(0, fullName.lastIndexOf(' '));
        lastName = fullName.substring(fullName.lastIndexOf(' ') + 1, fullName.length);
      } else {
        firstName = fullName;
      }

      const formattedFormData = {
        email: this.value.email,
        username: this.value.email,
        properties: {
          NewPassword: this.value.password,
          firstName: firstName,
          lastName: lastName,
          customerNo: this.value.customerNumber,
        }
      }

      try {
        const data = await this.$repositories.users.create(this.currentCulture, formattedFormData);

        if (data?.isValid) {
          trackFormSubmission('Create User Exisiting', 'Content', this.value.email);
          this.$emit('success', this.$t('createUserExistingCreatedMessage', 'Tillykke! Din konto er nu blevet oprettet. Vi har sendt dig en mail med yderligere oplysninger'));
          this.isLoading = false;
          return;
        }

        if (data?.message === 'Account not found') {
          this.$emit('customer-number-not-found');
          this.isLoading = false;
          return;
        }

        if (data?.message === 'User already exists') {
          this.errorMessage = this.$t('createUserExistingUserAlreadyExistsErrorMessage','Det ser ud til at en konto med denne email allerede findes.');
        }

        this.errorMessage = this.generalErrorMessage;
        this.showError = true;
      } catch (error) {
        this.errorMessage = this.generalErrorMessage;
        this.showError = true;
      }

      this.isLoading = false;
    }
  }
}
</script>
